import(/* webpackMode: "eager" */ "/www/wwwroot/www.zhubaofang.cn/website/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.jsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/www.zhubaofang.cn/website/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/www.zhubaofang.cn/website/src/components/nprogress/index.jsx");
